
import {
  ElMessage,
  ElMessageBox,
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,
  ElUpload,
  ElIcon,
} from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import phoneLogin from './phone-login/phoneLogin.vue'
import emailLogin from './email-login/emailLogin.vue'
// import CertificationDialog from '@/components/CertificationDialog.vue'

import { useRouter, useRoute } from 'vue-router'
import { defineComponent, onMounted, reactive, toRefs, computed, ref } from 'vue'
import api from '@/services'
import vuex from '@/store'
import { getLang } from '@/services/apis/lang'
import { $t as lang } from '@/Tool'
import { openTab } from '@/Tool/event'
export default defineComponent({
  components: {
    phoneLogin,
    emailLogin,
    // CertificationDialog,
    ElDialog,
    ElForm,
    ElFormItem,
    ElInput,
    ElButton,
    ElUpload,
    ElIcon,
    Plus,
  },
  setup() {
    onMounted(() => {
      istoken(localStorage.getItem('_localtoken') || '')
      getAllCertificationConfigs()
      // isLoggedin()
    })
    const language = localStorage.getItem('lang') || navigator.language.substr(0, 2)
    const data = reactive({
      isEmail: language == 'en' ? true : false,
      showCertificationDialog: false,
      pendingLoginInfo: null as any, // 待处理的登录信息
      authorizationRequired: false,
      forceCorpAuth: false,
      isRegistrationStep2: false, // 注册第二步状态
      successDialogVisible: false, // 认证成功弹窗
      suppressContinueOnClose: false, // 成功后关闭认证弹窗时，抑制自动继续登录
    })
    const menus = computed(() => vuex.state.menus)
    //根据token免登录
    const router = useRouter()
    const route = useRoute()
    async function istoken(localToken: string) {
      const token = route.query.token || localToken
      const redirect = route.query.redirect
      if (token) {
        vuex.commit('set_data', {
          user: { token: token },
        })
        const userInfoRes = await queryUserInfo()
        // console.log('userInfoRes', userInfoRes)
        const menuCodes = userInfoRes?.data?.menuCodes || []
        const hasHomePage = computed(() => menuCodes.indexOf('home') >= 0)
        if (userInfoRes.data && userInfoRes.success) {
          // 获取企业认证信息
          const entEditionInfo = await queryEntEditionInfo()
          if (entEditionInfo && entEditionInfo.success) {
            // 将企业认证信息添加到用户信息中
            userInfoRes.data.auditStatus = entEditionInfo.data.auditStatus
            userInfoRes.data.businessLicenseUrl = entEditionInfo.data.businessLicenseUrl
            userInfoRes.data.authorLetterUrl = entEditionInfo.data.authorLetterUrl
            userInfoRes.data.corpName = entEditionInfo.data.name
          }
          const registerCodeRes = await checkBindingRegisterCode(userInfoRes.data.mobile)
          if (registerCodeRes.success && registerCodeRes.data) {
            if (userInfoRes?.data.corpType == 1 && hasHomePage.value) {
              // if (userInfoRes?.data.type == 1 && hasHomePage.value) {
              // 1 企业 2个人
              vuex.commit('set_data', {
                user: {
                  token: token,
                  info: userInfoRes.data,
                  orgid: userInfoRes.data.corpId,
                },
                currentMicroDom: '/vshow/newHomePage',
              })
            } else {
              vuex.commit('set_data', {
                user: {
                  token: token,
                  info: userInfoRes.data,
                  orgid: userInfoRes.data.corpId,
                },
                currentMicroDom: '/vshow/workBench/newBench',
              })
            }
            initHomePage()
            // const newAccount = userInfoRes.data?.newAccount // 是否是新用户
            if (redirect) {
              router.push(redirect as string)
            } else {
              if (userInfoRes?.data.corpType == 1 && hasHomePage.value) {
                // 设置选中一级菜单
                menus.value.forEach((item: any) => {
                  item.isSelect = item.key === 'home'
                })
                vuex.commit('set_data', {
                  selectMenu: {
                    child: [],
                    icon: 'iconfont icon-moteshichang',
                    isSelect: true,
                    key: 'home',
                    label: '首页',
                    parentKey: '',
                    title: '首页',
                    name: '首页',
                    url: '/vshow/newHomePage',
                    visible: true,
                  },
                })
                router.push('/vshow/newHomePage')
              } else {
                // 设置选中一级菜单
                menus.value.forEach((item: any) => {
                  item.isSelect = item.key === 'workBench'
                })
                vuex.commit('set_data', {
                  selectMenu: {
                    child: [],
                    icon: 'iconfont icon-gongzuotai1',
                    isSelect: true,
                    key: 'workBench',
                    label: '工作台',
                    parentKey: '',
                    title: '工作台',
                    name: '工作台',
                    url: '/vshow/workBench',
                    visible: true,
                  },
                })
                router.push('/vshow/workBench/newBench')
              }
            }
          } else {
            ElMessage({
              message: '您没有绑定邀请码，请手动登录并绑定邀请码',
              type: 'warning',
            })
            localStorage.removeItem('_localtoken')
            router.push('/login')
          }
        } else {
          ElMessage({
            message: userInfoRes,
            type: 'warning',
          })
          localStorage.removeItem('_localtoken')
          router.push('/login')
        }
      }
    }

    // 根据路由判是否是第三方跳转过来的，第三方跳转过来界面上需要脱敏，隐去硅基的元素
    /* ;(async function isThirdPart() {
      const res = await api.ConfigServer.checkWhiteList({
        dictName: '小视频',
        childDictNameList: ['writeDomain']
      })
      if (res.success) {
        let writeDomain = res.data.childOption.find(
          (item: any) => 'writeDomain' === item.optionName,
        )?.optionValue
        if (writeDomain) {
          writeDomain = JSON.parse(writeDomain)
        }

        if (writeDomain.indexOf(location.hostname) >= 0) {
          sessionStorage.removeItem('is3Part')
          vuex.commit('set_data', {
            is3Part: false,
          })
        } else {
          sessionStorage.setItem('is3Part', 'true')
          vuex.commit('set_data', {
            is3Part: true,
          })
        }
      }
    })() */

    //根据token获取userinfo
    async function queryUserInfo() {
      try {
        const res: any = await api.Scrm_sys_api.srcmLogin.getUserInfo({
          error: false,
          success: false,
          data: {},
        })
        return res
      } catch (e) {
        return e
      }
    }

    // 获取企业认证信息
    async function queryEntEditionInfo() {
      try {
        const res: any = await api.Scrm_sys_api.srcmLogin.queryEntEditionInfoByCorpId({
          error: false,
          success: false,
        })
        return res
      } catch (e) {
        console.error('获取企业认证信息失败:', e)
        return null
      }
    }

    function isLoggedin() {
      // todo 已登录则自动跳转
      // console.log('userinfo', sessionStorage.getItem('__user'))
      if (sessionStorage.getItem('__user')) {
        const userInfo = JSON.parse(sessionStorage.getItem('__user') + '')
        if (userInfo) {
          gotoIndex(userInfo.user.token, userInfo as Record<string, unknown>, '', false)
        }
      }
    }

    function checkBindingRegisterCode(mobile: string) {
      return api.Scrm_sys_api.srcmLogin.bindingRegisterCodeCheck(
        {
          error: false,
        },
        mobile,
        true,
      )
    }

    //登录成功跳转函数
    async function loginSucceeded(info: any) {
      const { token, userInfo } = info.loginInfo ?? {}
      const shareId = info.shareId
      const noLogin = info.noLogin
      if (userInfo.accountLoggedTips) {
        ElMessageBox.alert(userInfo.accountLoggedTips, '', {
          confirmButtonText: data.isEmail ? 'OK' : '确定',
          callback: async () => {
            await gotoIndex(token, userInfo, shareId, noLogin)
          },
        })
      } else {
        await gotoIndex(token, userInfo, shareId, noLogin)
      }
      // clearInput()
    }
    async function gotoIndex(
      token: string,
      userInfo: Record<string, unknown>,
      shareId: string,
      noLogin: boolean,
    ) {
      const menuCodes: any = userInfo.menuCodes || []
      const hasHomePage = computed(() => menuCodes?.indexOf('home') >= 0)
      // if (userInfo.type !== 3 && userInfo.type !== 1) {
      //   // todo 临时方案，后端将非1，3的角色归为个人0，3表示代理商
      //   userInfo.type = 0
      // }
      vuex.commit('set_data', {
        user: {
          token: token,
          info: userInfo,
          orgid: userInfo.corpId,
        },
      })

      // 获取企业认证信息
      const entEditionInfo = await queryEntEditionInfo()
      if (entEditionInfo && entEditionInfo.success) {
        // 将企业认证信息添加到用户信息中
        userInfo.auditStatus = entEditionInfo.data.auditStatus
        userInfo.businessLicenseUrl = entEditionInfo.data.businessLicenseUrl
        userInfo.authorLetterUrl = entEditionInfo.data.authorLetterUrl
        userInfo.corpName = entEditionInfo.data.name

        // 更新用户信息到vuex
        vuex.commit('set_data', {
          user: {
            token: token,
            info: userInfo,
            orgid: userInfo.corpId,
          },
        })

        // 检查企业认证状态
        /* if (userInfo.auditStatus !== 2 && userInfo.type !== 3) {
          // 未通过企业认证，显示认证弹窗
          data.pendingLoginInfo = { token, userInfo, shareId, noLogin }
          data.showCertificationDialog = true
          return // 暂停登录流程，等待认证完成
        } */
      }
      // 继续登录流程
      continueLoginProcess(token, userInfo, shareId, noLogin)
    }

    // 判断是否有首页权限
    const initHomePage = () => {
      let userInfo: any = {}
      if (sessionStorage.getItem('__user')) {
        userInfo = JSON.parse(sessionStorage.getItem('__user') + '')
      }
      const menuCodes = userInfo?.user.info?.menuCodes || []
      const hasHomePage = computed(() => menuCodes.indexOf('home') >= 0)
      if (userInfo.user?.info?.corpType == 1 && hasHomePage.value) {
        // 1 企业 ，2个人
        // 设置选中一级菜单
        menus.value.forEach((item: any) => {
          item.isSelect = item.key === 'home'
        })
        vuex.commit('set_data', {
          tabsArr: [
            {
              key: 'home',
              name: `${lang('mainMenu.firstMenu.home')}&home`,
              url: '/vshow/newHomePage',
              parentKey: '',
              child: [],
            },
          ],
          activeTabName: `${lang('mainMenu.firstMenu.home')}&home`,
        })
      } else {
        vuex.commit('set_data', {
          tabsArr: [
            {
              key: 'workBench',
              name: `${lang('mainMenu.firstMenu.workBench')}&workBench`,
              url: '/vshow/workBench/newBench',
              parentKey: '',
              child: [],
            },
          ],
          activeTabName: `${lang('mainMenu.firstMenu.workBench')}&workBench`,
        })
      }
    }
    // 切换中英文
    const langChange = (lang) => {
      localStorage.setItem('lang', lang)
      data.isEmail = lang == 'en' ? true : false
      location.reload()
    }

    // 处理注册步骤变化
    const handleRegistrationStepChange = (step: number) => {
      data.isRegistrationStep2 = step === 2
    }

    // 企业认证成功处理（作为success事件的处理）
    const handleCertificationSubmit = async (response: any) => {
      // 标记：这是成功触发的关闭，后续关闭回调不应继续登录
      data.suppressContinueOnClose = true
      data.showCertificationDialog = false
      // 仅弹出成功弹窗，不做跳转
      data.successDialogVisible = true
    }

    // 处理成功确认
    const handleSuccessConfirm = async () => {
      data.successDialogVisible = false
      data.pendingLoginInfo = null
      // 成功后不进入工作台，按之前要求始终回登录页
      const isHuawei = sessionStorage.getItem('isHuaweiyun')
      try {
        await api.Scrm_sys_api.srcmLogin.loginOut({
          error: false,
          success: false,
          data: {},
        })
      } catch (error) {
        console.error('退出登录失败:', error)
      } finally {
        vuex.commit('clear_data')
        sessionStorage.clear()
        localStorage.removeItem('__user')
        if (isHuawei === 'huawei') {
          router.replace('/huaweiyun/login')
        } else {
          router.replace('/login')
        }
        location.reload()
      }
    }

    // 企业认证取消处理
    const handleCertificationCancel = () => {
      data.showCertificationDialog = false
      // 若是成功触发的关闭，则不应继续登录流程
      if (data.suppressContinueOnClose) {
        data.suppressContinueOnClose = false
        return
      }
      if (data.pendingLoginInfo) {
        const { token, userInfo, shareId, noLogin } = data.pendingLoginInfo
        continueLoginProcess(token, userInfo, shareId, noLogin)
        data.pendingLoginInfo = null
      }
    }

    // 继续登录流程
    const continueLoginProcess = (
      token: string,
      userInfo: any,
      shareId: string,
      noLogin: boolean,
    ) => {
      const menuCodes: any = userInfo.menuCodes || []
      const hasHomePage = computed(() => menuCodes?.indexOf('home') >= 0)

      if (noLogin) {
        localStorage.setItem('_localtoken', token)
      } else {
        localStorage.removeItem('_localtoken')
      }
      sessionStorage.setItem('firstLogin', 'true')

      // 获取语言包
      getLang().then((result) => {
        vuex.commit('set_data', {
          langPackage: result.data,
        })
        initHomePage()
        ElMessage({
          message: data.isEmail ? 'Login succeeded' : lang('mainTip.login.success.title'),
          type: 'success',
        })

        // 根据用户类型和权限跳转
        if (userInfo.corpType == 1 && hasHomePage.value) {
          menus.value.forEach((item: any) => {
            item.isSelect = item.key === 'home'
          })
          vuex.commit('set_data', {
            selectMenu: {
              child: [],
              icon: 'iconfont icon-moteshichang',
              isSelect: true,
              key: 'home',
              label: '首页',
              parentKey: '',
              title: '首页',
              url: '/vshow/newHomePage',
              visible: true,
            },
          })
          router.push('/vshow/newHomePage')
        } else {
          menus.value.forEach((item: any) => {
            item.isSelect = item.key === 'workBench'
          })
          vuex.commit('set_data', {
            selectMenu: {
              child: [],
              icon: 'iconfont icon-gongzuotai1',
              isSelect: true,
              key: 'workBench',
              label: '工作台',
              parentKey: '',
              title: '工作台',
              url: '/vshow/workBench',
              visible: true,
            },
          })
          router.push('/vshow/workBench/newBench')
        }

        if (shareId) {
          setTimeout(() => {
            openTab({
              title: `${lang('login.model.option')}-${shareId}`,
              url: `/vshow/modelDetail/${shareId}`,
            })
            menus.value.forEach((item: any) => {
              item.isSelect = item.key === 'digitalMarket'
            })
            vuex.commit('set_data', {
              selectMenu: {
                child: [],
                icon: 'iconfont icon-gongzuotai1',
                isSelect: true,
                key: 'digitalMarket',
                label: '数字市场',
                parentKey: '',
                title: '数字市场',
                url: '/vshow/digitalMarket',
                visible: true,
              },
            })
          }, 100)
        }
      })
    }

    // 认证相关方法
    const getAllCertificationConfigs = async () => {
      try {
        const response = await api.ConfigServer.getDictByName('服务升级')
        if (response.success && response.data?.childOption) {
          const options = response.data.childOption
          // 授权书必填（和认证栏统一，相同逻辑字段 letterAuthorization，值等于 '1' 时必填）
          const authOption = options.find((item: any) => item.optionName === 'letterAuthorization')
          data.authorizationRequired = authOption?.optionValue === '1'
          // 强制认证配置
          const forceAuthOption = options.find((item: any) => item.optionName === 'forceCorpAuth')
          data.forceCorpAuth = forceAuthOption?.optionValue === '1'
        } else {
          data.authorizationRequired = false
          data.forceCorpAuth = false
        }
      } catch (error) {
        console.error('获取配置失败:', error)
        data.authorizationRequired = false
        data.forceCorpAuth = false
      }
    }

    return {
      ...toRefs(data),
      initHomePage,
      loginSucceeded,
      lang,
      langChange,
      handleCertificationSubmit,
      handleCertificationCancel,
      handleRegistrationStepChange,
      handleSuccessConfirm,
    }
  },
})
